<template>
  <el-container ref="wrapper">
    <div class="tips flex-aj-c" v-show="tipShowFlag">
      <img src="./img/tips.png" class="tip-img" alt="">
      清露平台所载所有内容，仅限于内部学习使用。各位同学不得将本平台所载内容用作其他用途，或提供给其他人使用
      <img src="./img/closed.png" class="close" @click="tipShowFlag = false" alt="">
    </div>
    <el-header height="82px" v-show="headershow2" :class="headershow ? 'el-header-in' : 'el-header-out'">
      <div class="type_page">
        <div class="flex-a-c">
          <img src="./img/title.png" alt="" class="logo-img" @click="toHome" />
        </div>
        <!-- 首页菜单按钮 -->
        <div class="my_ment">
          <div class="ment" :class="menuActiveIndex == '1' ? 'ment_active' : ''" @mouseover="changeMent(1)"
            @mouseout="changeMouseout" @click="changeChildIndex({ title: '精品课堂', id: 0 }, -1)">
            首页
          </div>
          <!-- 其他分类菜单按钮 -->
          <div class="ment" v-for="(item, index) in menuList" :key="item.id"
            :class="menuActiveIndex == item.id ? 'ment_active' : ''" @mouseover="changeMent(item.id, index)"
            @mouseout="changeMouseout">
            {{ item.title }}
            <i class="iconfont fs12"
              :class="submeunFlag && menuActiveIndex == item.id ? 'icon-xiangshang' : 'icon-xiangxia'"
              style="color:#A8ABB2;margin-left:2px"></i>
          </div>
          <!-- 二级菜单 -->
          <div class="ment_child" @mouseover="changeMouseoverFlag" @mouseout="changeChildMouseout" v-show="submeunFlag">
            <div class="type_page">
              <div v-for="(item, index) in submenuList" :key="index" :class="submenuActiveIndex == index && menuActiveIndex != 3
                ? 'ment_child_box active'
                : 'ment_child_box'
                " @click="changeChildIndex(item, index)">
                <span class="ment_child_box_title">{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; align-items: center">
          <el-input placeholder="输入搜索教程" v-model="searchInput" @keyup.enter.native="search" class="search-input">
            <i slot="suffix" class="el-input__icon el-icon-search fs16 cursor-p" @click="search()"></i>
          </el-input>
          <UserHeader></UserHeader>
          <el-button type="goon" class="guanli" v-if="showFlag" @click="goManage">管理中心</el-button>
        </div>
      </div>
    </el-header>
    <el-main>
      <router-view ref="Childmain" @backtop="backtop" />
    </el-main>
  </el-container>
</template>

<script>
import UserHeader from '@/components/user-header'
export default {
  name: "count_center",
  components: {
    UserHeader
  },
  data() {
    return {
      tipShowFlag: true,  // 首页顶部提示是否显示
      headershow2: true,
      headershow: true,
      oldScrollTop: 0, // 判断滚动是上还是下
      submeunFlag: false, // 二级菜单开关
      menuActiveIndex: 1,  // 一级菜单索引
      origin_menuActiveIndex:1, // 一级菜单索引原始值
      submenuActiveIndex: -1,  // 二级菜单索引
      currentCourseId: "", //当前课程分类id
      showFlag: false,   // 管理中心按钮权限
      titlist: [], // 在线课程子菜单
      submenuList: [], // 二级子菜单
      menuList: [], // 动态菜单栏
      techList: [], // 技术栈的数据
      searchInput: "",
      timer: null
    };
  },
  beforeDestroy() {
    window.removeEventListener('wheel', this.handWheel)
  },
  watch: {
    $route(to, from) {
      if (to.path == '/count_center/list' && from.path.indexOf('/manage_center') > -1) {
        this.$refs.Childmain.navClick({ cate: '' })
      }
    }
  },
  mounted() {
    this.initInfo();
    this.getCate()
    this.getMenuIndex() // 设置导航栏
    // 先从本地缓存获取课程分类，防止跳转了无数据
    const cate = JSON.parse(localStorage.getItem('courseCate'))
    this.dealCate(cate)
    window.addEventListener('wheel', this.handWheel, true)
  },
  methods: {
    toHome() {
      this.$router.replace('/count_center/list').catch(err => err)
    },
    // 回到顶部
    backtop() {
      this.headershow = true
      this.headershow2 = true
    },
    // 滚动
    handWheel(e) {
      const event = e || window.event;
      if (event.wheelDelta > 0) {
        this.headershow = true
        this.headershow2 = true
      } else {
        this.headershow = false
        setTimeout(() => {
          this.headershow2 = false
        }, 300)
      }
    },

    search() {
      this.$refs.Childmain.navClick({ search: this.searchInput, cate: this.currentCourseId })
    },
    // 获取课程分类
    async getCate() {
      const [err, res] = await this.$http.get("home/course/cate");
      if (err) {
        return;
      }
      this.dealCate(res.list || res)
    },

    // 处理课程分类数据，动态生成菜单
    dealCate(obj) {
      if (!obj || !Array.isArray(obj)) return;
      
      // 根据第一层ID从小到大排序
      const sortedObj = obj.sort((a, b) => a.id - b.id);
      
      // 动态生成菜单列表
      this.menuList = sortedObj.map((category, index) => {
        const menuItem = {
          id: index + 2, // 从2开始，1是首页
          title: category.cate_name,
          children: []
        };
        
        // 处理子分类
        if (category.children && category.children.length > 0) {
          if (category.cate_name === "技术栈") {
            // 技术栈特殊处理，保存到techList
            this.techList = category.children.map(child => ({
              id: child.id,
              title: child.cate_name,
              url: child.links_src || ""
            }));
            menuItem.children = this.techList;
          } else {
            // 其他分类处理为普通子菜单
            menuItem.children = category.children.map(child => ({
              title: child.cate_name,
              id: child.id,
            }));
          }
        }
        
        return menuItem;
      });
      
      this.getMenuIndex()
    },
        // 获取当前菜单所在位置
    getMenuIndex() {
      const query = this.$route.query
      if (query.courseid && this.menuList.length > 0) {
        // 动态查找包含该课程ID的菜单项
        let foundMenuIndex = -1;
        let foundSubmenuIndex = -1;
        
        for (let i = 0; i < this.menuList.length; i++) {
          const menu = this.menuList[i];
          if (menu.children && menu.children.length > 0) {
            const subIndex = menu.children.findIndex(el => el.id == query.courseid);
            if (subIndex !== -1) {
              foundMenuIndex = i + 2; // 菜单ID从2开始
              foundSubmenuIndex = subIndex;
              break;
            }
          }
        }
        
        this.submenuActiveIndex = foundSubmenuIndex;
        this.menuActiveIndex = foundSubmenuIndex == -1 ? 1 : foundMenuIndex;
        this.currentCourseId = query.courseid;
      }
    },
    initInfo() {
      let user_info = JSON.parse(localStorage.getItem("user_info"));
      if (user_info.is_admin) {
        this.showFlag = true;
      }
    },

    changeChildIndex(item, index) {
      if (item.url) {
        // 说明是外部链接
        return window.open(item.url)
      }
      // 如果搜索了想直接切换重新请求
      if (this.searchInput) {
        this.searchInput = ''
        this.$refs.Childmain.navClick({ cate: item.id, course: item.title, search: '' })
      }
      // 防止重复跳转
      if (this.currentCourseId == item.id) return
      this.searchInput = ''
      this.submenuActiveIndex = index;
      this.$router.replace(`/count_center/list?courseid=${item.id}&course=${item.title}`).catch(err => { err })
      this.$refs.Childmain.navClick({ cate: item.id, course: item.title, search: '' })
    },
    // 一级菜单鼠标移入
    changeMent(id, index) {
      if (id != 1) {
        this.submeunFlag = true;
        this.submenuList = this.menuList[index].children
      }
      this.menuActiveIndex = id;
      // 一级菜单是原始值，不会重置到选中状态的值
      this.origin_menuActiveIndex = id;
    }, 
    // 一级菜单移除
    changeMouseout() {
      this.submeunFlag = false;
      this.getMenuIndex()
    },
    // 二级菜单鼠标移出
    changeChildMouseout() {
      this.submeunFlag = false;
      this.getMenuIndex()
    },
    // 二级菜单鼠标移入
    changeMouseoverFlag() {
      this.submeunFlag = true;
      this.menuActiveIndex = this.origin_menuActiveIndex
    },
    goManage() {
      this.$router.push("/manage_center");
    },
  },

};
</script>

<style lang="less" scoped>
.search-input {
  width: 340px;
}

:deep(.search-input input) {
  border-radius: 44px !important;
}

/deep/ .el-main {
  padding: 0;
  overflow: initial;

}

.el-header {
  padding: 0;
  background: #201f1f;
  line-height: 82px;
  position: sticky;
  top: 0;
  z-index: 9999;

}

.el-header-in {
  animation: in 0.5s;
  display: block;
}

.el-header-out {
  animation: out 0.5s;
}

@keyframes in {
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translateY(0%);
  }
}

@keyframes out {
  from {
    transform: translateY(0%);
  }

  to {
    transform: translateY(-100%);
  }
}

.my_ment {
  display: flex;
  height: 82px;
  margin-left: 47px;
  flex: 1;

  .ment_child {
    position: absolute;
    width: 100%;
    height: 75px;
    top: 82px;
    left: 0;
    background: #333131;
    z-index: 9999;

    .ment_child_box {
      cursor: pointer;
      width: 116px;
      height: 75px;
      display: flex;
      justify-content: center;
      align-items: center;

      .ment_child_box_title {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.5);

        &:hover {
          color: #FFF;
        }
      }

      img {
        width: 24px;
        height: 24px;
      }
    }

    .active {
      // width: 88px;
      height: 39px;
      color: #FFF !important;
      background: #2ab18b;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 58px 58px 58px 58px;
      cursor: pointer;

      .ment_child_box_title {
        font-size: 14px;
        color: #FFF;
        // color: #23262f;
      }

      img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .ment {
    font-size: 14px;
    color: #fff;
    padding: 0 16px;
    // width: 95px;
    text-align: center;
    cursor: pointer;
  }

  .ment_active {
    background: #333131;
  }
}



.el-button--goon,
.el-button--goon:focus,
.el-button--goon.is-active,
.el-button--goon:active {
  background: #2ab18b;
  border-color: #2ab18b;
  color: #fff;
}

.el-button--goon:hover {
  background: #8cd8da;
  border-color: #8cd8da;
  color: #fff;
}

.el-icon-search {
  color: #23262F;
}

.guanli {
  border-radius: 44px;
}

.logo-img {
  width: 90px;
  cursor: pointer;
}

.tips {
  height: 40px;
  background: #2AB18B;
  color: #FFF;
  font-size: 14px;
  position: relative;

  .tip-img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .close {
    cursor: pointer;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 30px;
  }
}

._a {
  color: #FFF;
  text-decoration: none;
}
</style>
